import React from "react";

function ChallengeDetailModal({ challenge, onClose }) {
  if (!challenge) return null;

  const statusLower = (challenge.status || "").toLowerCase();
  const isApproved = statusLower === "approved";
  const visibilityLower = (challenge.Visibility || "").toString().toLowerCase();
  const isPublic = visibilityLower === "true";

  const phoneDisplay =
    challenge.PhoneNumber && !String(challenge.PhoneNumber).startsWith("#")
      ? String(challenge.PhoneNumber).replace(/^'/, "")
      : "—";

  return (
    <div
      className="innovation-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="challenge-modal-title"
    >
      <div className="innovation-modal" onClick={(e) => e.stopPropagation()}>
        <div className="innovation-modal-header">
          <div className="innovation-modal-header-top">
            <h3 id="challenge-modal-title" className="innovation-modal-title">
              {challenge.Title || "Challenge"}
            </h3>
            <span className="innovation-modal-type-badge">
              {challenge.type || "CHALLENGE"}
            </span>
          </div>
          <div className="innovation-modal-meta">
            <span className="innovation-modal-date">
              {challenge.Date
                ? new Date(challenge.Date).toLocaleString(undefined, {
                    dateStyle: "medium",
                    timeStyle: "short",
                  })
                : "—"}
            </span>
            <span className="innovation-modal-id">ID: {challenge.ID || "—"}</span>
          </div>
        </div>

        <div className="innovation-modal-section">
          <h4 className="innovation-modal-section-title">Organization & Contact</h4>
          <dl className="innovation-modal-dl">
            <div className="innovation-modal-row">
              <dt>Organization</dt>
              <dd>{challenge.OrganizationName || "—"}</dd>
            </div>
            <div className="innovation-modal-row">
              <dt>Contact name</dt>
              <dd>{challenge.ContactName || "—"}</dd>
            </div>
            <div className="innovation-modal-row">
              <dt>Job title</dt>
              <dd>{challenge.JobTitle || "—"}</dd>
            </div>
            <div className="innovation-modal-row">
              <dt>Email</dt>
              <dd>
                {challenge.Email ? (
                  <a href={`mailto:${challenge.Email}`} className="innovation-modal-link">
                    {challenge.Email}
                  </a>
                ) : (
                  "—"
                )}
              </dd>
            </div>
            <div className="innovation-modal-row">
              <dt>Phone</dt>
              <dd className="innovation-modal-phone">{phoneDisplay}</dd>
            </div>
          </dl>
        </div>

        <div className="innovation-modal-section">
          <h4 className="innovation-modal-section-title">Challenge Description</h4>
          <div className="innovation-modal-body">
            {challenge.ChallengeDescription || "—"}
          </div>
        </div>

        <div className="innovation-modal-status-bar">
          <span
            className={`innovation-modal-status innovation-modal-status--${statusLower || "pending"}`}
          >
            {isApproved ? "Approved" : "Pending"}
          </span>
          <span
            className={`innovation-modal-visibility ${
              isPublic ? "innovation-modal-visibility--public" : "innovation-modal-visibility--private"
            }`}
          >
            {isPublic ? "Public" : "Private"}
          </span>
        </div>

        <div className="innovation-modal-footer">
          <button
            type="button"
            className="innovation-modal-close-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChallengeDetailModal;
